/**
 * Die Fehlermeldung aus einer Antwort der API.
 *
 * Das Format steht in `packages/contracts/src/common.ts`: `{ error: { code,
 * message } }`. Die Meldung ist bereits für Menschen geschrieben und auf Deutsch
 * — sie hier durch eine eigene zu ersetzen, verlöre den Grund. Der Server weiß,
 * *warum* etwas nicht ging; die Oberfläche weiß nur, *dass*.
 */
export function apiErrorMessage(failed: unknown): string | undefined {
  return (failed as { error?: { message?: string } } | undefined)?.error?.message;
}
